import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HighchartsChartModule } from 'highcharts-angular';

import { ReportsRoutingModule } from './reports-routing.module';
import { AppSharedModule } from '../app-shared.module';
import { ReportsStaticComponent } from './reports-static/reports-static.component';
import { ReportsLiveIndexComponent } from './reports-live/reports-live-index/reports-live-index.component';
import { ReportLiveItsmComponent } from './reports-live/report-live-itsm/report-live-itsm.component';
import { ReportLiveSecurityCaseComponent } from './reports-live/report-live-securitycase/report-live-securitycase.component';


@NgModule({
  declarations: [
    ReportsStaticComponent,
    ReportsLiveIndexComponent,
    ReportLiveItsmComponent,
    ReportLiveSecurityCaseComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    ReportsRoutingModule,
    AppSharedModule,
    HighchartsChartModule
  ],
  exports: [ ReportsStaticComponent, ReportsLiveIndexComponent, ReportLiveSecurityCaseComponent ],
  bootstrap: [ ReportsStaticComponent, ReportsLiveIndexComponent, ReportLiveSecurityCaseComponent ]
})
export class ReportsModule { }
